import React from "react";
import Checkmark from '../assets/Checkmark.png'

const CheckMarkSection = ({ label, title }) => {
    return (
        <div style={{ marginTop: '20px', }}>
            <div style={{ display: 'flex', flexDirection: 'row', }}>
                <img src={Checkmark} style={{ width: '15px', height: '12px', marginRight: '4px', marginTop: '4px' }} />
                <label style={{ color: '#5E5E5E', fontSize: '18px', fontWeight: '500' }}>{title}</label>
            </div>
            <label style={{ color: '#5E5E5E', fontSize: '16px', display: 'flex', marginTop: '7px' }}>{label}</label>
        </div>)
}

export default CheckMarkSection